//export { default as SplashScreen } from "./SplashScreen";
//export { default as HomeScreen } from "./HomeScreen";
//export { default as TokenScreen } from "./TokenScreen";
//export { default as TransactionScreen } from "./TransactionScreen";
//export { default as TokenDistScreen } from "./TokenDistScreen";
//export { default as FaucetScreen } from "./FaucetScreen";
//export { default as FaqScreen } from "./FaqScreen";
//export { default as ContactScreen } from "./ContactScreen";

export { default as LoadingScreen } from "./LoadingScreen";
//export { default as ErrorScreen } from "./ErrorScreen";
